import { queryOptions } from '@tanstack/react-query';
import { getEmpresaIdpk } from '@/features/login/util';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import type { MarcadorLocal } from '../types/enum';
import { MarcadorSchema } from '../types/Marcador';

type ApiMarcadorGetParams = Partial<{
    empresa_idpk: number;
    local: MarcadorLocal | MarcadorLocal[];
    pesquisar: string;
    orderby: string;
}>;

const schema = registrosSchema(MarcadorSchema);

function apiMarcadorGet(params?: ApiMarcadorGetParams) {
    const local =
        params?.local !== undefined
            ? Array.isArray(params.local)
                ? `[${params.local.toString()}]`
                : `[${params.local}]`
            : undefined;

    return fetchApi({
        endpoint: 'Marcador/Consultar',
        method: 'get',
        params: {
            empresa_idpk: params?.empresa_idpk || getEmpresaIdpk(),
            local,
            orderby: params?.orderby,
            pesquisar: params?.pesquisar,
        },
        schema,
    });
}

export const API_MARCADOR_GET_KEY = 'apiMarcadorGet';

export function apiMarcadorGetQueryOptions(params?: ApiMarcadorGetParams) {
    return queryOptions({
        queryFn: () => apiMarcadorGet(params),
        queryKey: [API_MARCADOR_GET_KEY, params],
    });
}
